import { NamePath } from 'antd/lib/form/interface';

export default function getPath(paths: NamePath = [], ...restPath: NamePath[]): NamePath {
  return [...[paths].flat(2), ...restPath].flat();
}
